import { createContext, useContext, useEffect, useState } from 'react';
import { fetchAllProducts1 } from '../components/Service/ProductService';
import { useRegion } from './RegionsContext';
const ServerContext = createContext();

export const ServerProvider = ({ children }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchAllProducts1('vn');
                setData(response?.systems || []);
            } catch (error) {
                console.error("Error fetching server data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <ServerContext.Provider value={{ data, loading }}>
            {children}
        </ServerContext.Provider>
    );
};

export const useData = () => useContext(ServerContext);
